import { Navigate } from "react-router-dom";
import useToken from "../useToken";
import Header from "../components/header/Header";

function useQuery() {
  return new URLSearchParams(window.location.search);
}

const ProtectedRoute = ({ children, client, isNotFound }) => {
  const query = useQuery();
  const uniqueId = query.get("u");
  const { token } = useToken();

  if (!token && !uniqueId) {
    return (
      <Navigate to={`${process.env.REACT_APP_ORDER_FORM}/login`} replace />
    );
  } else {
    return (
      <>
        {!isNotFound && <Header />}
        {children}
      </>
    );
  }
};

export default ProtectedRoute;
